import React, { useState } from "react";
import workData from "./Work.json";
import { useLang } from "./LanguageContext";
import t from "./translations";
import "./Work.css";

const Work = () => {
  const [selectedWork, setSelectedWork] = useState(null);
  const { lang } = useLang();
  const { work } = t[lang];

  const handleCardClick = (w) => setSelectedWork(w);
  const closeModal = () => setSelectedWork(null);

  return (
      <section id="work" className="work-section">
        <h2 className="work-heading">{work.heading}</h2>
        <div className="work-container">
          {workData.map((work, index) => (
            <div
              key={index}
              className="work-card"
              onClick={() => handleCardClick(work)}
            >
              <div className="work-header">
                <h3 className="work-title">{work.title}</h3>
                <h4 className="work-company">{work.company}</h4>
              </div>
              <div className="work-meta">
                {work.duration && <p className="work-duration">{work.duration}</p>}
                {work.location && <p className="work-location">{work.location}</p>}
              </div>
              <p className="work-description">
                {work.description.split("\n")[0]}...
              </p>
            </div>
          ))}
        </div>

        {/* Modal for detailed view */}
        {selectedWork && (
          <div className="modal-overlay" onClick={closeModal}>
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()} // Prevent closing modal when clicking inside
            >
              <h3 className="modal-title">{selectedWork.title}</h3>
              <h4 className="modal-company">{selectedWork.company}</h4>
              <p className="modal-meta">
                {selectedWork.duration} | {selectedWork.location}
              </p>
              <p className="modal-description" style={{ whiteSpace: "pre-line" }}>
                {selectedWork.description}
              </p>
              {selectedWork.skills && (
                <p className="modal-skills">
                  <strong>Skills:</strong> {selectedWork.skills}
                </p>
              )}
              <button className="modal-close" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        )}
      </section>
  );
};

export default Work;
